import { Navigate, useLocation } from "react-router-dom";
import { AccessDenied } from "../Pages/AccessDenied";
import useAuth, { authData } from "./AuthProvider";
import { AppRoutes } from "../helper/appRoutes";

// export type ProtectedRouteProps = {
//     isAuthenticated: boolean;
//     authenticationPath: string;
//     roles:string[]
//     outlet: JSX.Element;
//   };

//   export default function ProtectedRoute({
//     isAuthenticated,
//     authenticationPath,
//     roles,
//     outlet,
//   }: ProtectedRouteProps) {
//     if (isAuthenticated) {
//       return outlet;
//     } else {
//       return <Navigate to={{ pathname: authenticationPath }} />;
//     }
//   }


export const PrivateRoute = ({
  children,
  roles,
  currentUser,
  loading,
  requireDiligentSearchUser,
}: {
  children: JSX.Element;
  roles: string[];
  currentUser: authData | undefined;
  loading: boolean;
  /** When true, also requires isDiligentSearchUser from auth; shows AccessDenied otherwise. */
  requireDiligentSearchUser?: boolean;
}) => {
  let location = useLocation();
  const { isDiligentSearchUser, hasAnyDiligentPartner } = useAuth();

  if (loading) {
    return <p className="heading">Checking auth..</p>;
  }

  const userHasRequiredRole = roles?.length <= 0 ? true : (currentUser && roles.filter(r => currentUser.userRoles.split(",").includes(r)).length > 0 ? true : false);
  const isAuthenticated: boolean = currentUser ? true : false;
  const isUserMISCOrSuperAdmin = ['MISC Filer', 'MISC State Reporter', 'Super Admin'].some(r => currentUser?.userRoles.split(",").includes(r));

  if (!isAuthenticated) {
    return <Navigate to={AppRoutes.login} state={{ from: location }} />;
  }

  if (isAuthenticated && !userHasRequiredRole) {
    return <AccessDenied />;
  }

  if (requireDiligentSearchUser && !isUserMISCOrSuperAdmin) {
    if (isDiligentSearchUser === null || hasAnyDiligentPartner === null) {
      return <p className="heading">Checking auth..</p>;
    }
    // Must be diligent search user per API and have at least one partner in #DiligentSearchPartners (API HasAnyDiligentPartner).
    if (!isDiligentSearchUser || !hasAnyDiligentPartner) {
      return <AccessDenied />;
    }
  }

  return children;
};